import React, { useState, useEffect } from 'react';

/**
 * AnnouncementBanner
 * - NO dismiss/X button — banners close only when they expire or are paused by admin
 * - Icon is a Font Awesome class string stored in DB (e.g. "fa-bullhorn")
 * - Place at top of business Dashboard.js
 * Usage: <AnnouncementBanner plan={user?.plan || 'free'} />
 */
const AnnouncementBanner = ({ plan = 'free' }) => {
  const [announcements, setAnnouncements] = useState([]);

  useEffect(() => {
    // Load Font Awesome if not already present
    if (!document.getElementById('fa-cdn-banner')) {
      const fa = document.createElement('link');
      fa.id = 'fa-cdn-banner';
      fa.rel = 'stylesheet';
      fa.href = 'https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.5.0/css/all.min.css';
      document.head.appendChild(fa);
    }

const base = process.env.REACT_APP_API_URL || 'https://janimony-backend.onrender.com/api';
    
    const token = localStorage.getItem('janimony_token');

    fetch(`${base}/api/admin/announcements/active?plan=${plan}`, {
      headers: token ? { Authorization: `Bearer ${token}` } : {}
    })
      .then(r => r.json())
      .then(res => { if (res.success) setAnnouncements(res.announcements || []); })
      .catch(() => {}); // silent — never break the dashboard
  }, [plan]);

  if (!announcements.length) return null;

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 10, marginBottom: 20 }}>
      {announcements.map(a => (
        <div key={a.id} style={{
          background: a.bg_color || '#667eea',
          borderRadius: 12,
          padding: '16px 20px',
          display: 'flex',
          alignItems: 'center',
          gap: 16,
          flexWrap: 'wrap',
          boxShadow: '0 4px 15px rgba(0,0,0,0.12)',
          // No position:relative, no X button at all
        }}>
          {/* FA Icon */}
          <div style={{
            width: 42, height: 42, borderRadius: '50%',
            background: 'rgba(255,255,255,0.2)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            flexShrink: 0
          }}>
            <i className={`fa-solid ${a.icon || 'fa-bullhorn'}`} style={{ color: '#fff', fontSize: 17 }}></i>
          </div>

          {/* Text */}
          <div style={{ flex: 1, minWidth: 0 }}>
            <div style={{ color: '#fff', fontWeight: 800, fontSize: 14, marginBottom: 3 }}>{a.title}</div>
            <div style={{ color: 'rgba(255,255,255,0.85)', fontSize: 13, lineHeight: 1.4 }}>{a.message}</div>
          </div>

          {/* CTA button — only if admin set one */}
          {a.cta_text && a.cta_link && (
            <a href={a.cta_link} target="_blank" rel="noopener noreferrer" style={{
              padding: '9px 18px',
              background: 'rgba(255,255,255,0.95)',
              color: a.bg_color || '#667eea',
              borderRadius: 8, fontWeight: 800, fontSize: 13,
              textDecoration: 'none', flexShrink: 0,
              display: 'flex', alignItems: 'center', gap: 6
            }}>
              {a.cta_text}
              <i className="fa-solid fa-arrow-right" style={{ fontSize: 11 }}></i>
            </a>
          )}
        </div>
      ))}
    </div>
  );
};

export default AnnouncementBanner;